import { jsx } from "panel";
import { TooltipEl } from "common/components/tooltip";
export function template() {
  const {
    iconSize
  } = this.helpers.getIconProperties();
  const avatarSrc = this.helpers.getAvatarSrc();
  return /* @__PURE__ */ jsx("div", { sel: `.container${this.attr(`enable-outline`) ? `.outlined` : ``}`, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("img", { attrs: {
    elref: `userImg`,
    align: `middle`,
    src: avatarSrc
  }, style: {
    height: `${iconSize}px`,
    width: `${iconSize}px`
  } }), this.helpers.isTooltipEnabled() ? /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: this.attr(`tooltip-placement`)
  } }, this.attr(`tooltip-text`)) : null);
}
